import {
  ResponsiveCard,
  type ResponsiveCardProps,
} from '@framework/ui/components/card/ResponsiveCard.tsx';
import styled from 'styled-components';

const StyledDossierResponsiveCard = styled(ResponsiveCard)`
  &&& {
    > .ant-card-cover,
    > .ant-card-head,
    > .ant-card-body {
      background-color: ${props => props.theme.colorBgDossierCard};
    }
  }
`;

export interface IDossierResponsiveCardProps extends ResponsiveCardProps {}

/**
 * ResponsiveCard personalizzata
 */
export function DossierResponsiveCard(props: IDossierResponsiveCardProps) {
  return <StyledDossierResponsiveCard {...props} />;
}
